// Fetch Goods
export const START_BOOKS_FETCH = 'START_BOOKS_FETCH'
export const COMPLETE_BOOKS_FETCH = 'COMPLETE_BOOKS_FETCH'

// Fetch Invoices
export const START_INVOICES_FETCH = 'START_INVOICES_FETCH'
export const COMPLETE_INVOICES_FETCH = 'COMPLETE_INVOICES_FETCH'

export const ADD_TO_CART = 'ADD_TO_CART'
export const EMPTY_CART = 'EMPTY_CART'
export const SELECTED_GOODS = 'SELECTED_GOODS'
export const DELETE_GOODS = 'DELETE_GOODS'

export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE'



// WEBPACK FOOTER //
// ./src/Shop/constants/types.js